module.exports = require("./km.d.ts");